(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aba-national-teams"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.aba-nl-picker[open]').forEach(picker=>{if(!picker.contains(event.target))picker.open=false})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.aba-nl-picker[open]').forEach(picker=>{picker.open=false;picker.querySelector('summary').focus()})});
document.addEventListener('toggle',event=>{if(event.target.matches('.aba-nl-picker')&&event.target.open)document.querySelectorAll('.aba-nl-picker[open]').forEach(other=>{if(other!==event.target)other.open=false})},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aba-player-shop"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-player-direction]');if(!button)return;const section=button.closest('.aba-player-shop');const track=section.querySelector('.aba-player-track');const card=track.querySelector('.aba-player-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:Number(button.dataset.playerDirection)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aba-store-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.aba-fast-menu[open],.aba-desktop-dropdown[open],.aba-custom[open],.aba-category[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false})});
document.querySelectorAll('.aba-desktop-dropdown').forEach(function(item){item.addEventListener('toggle',function(){if(item.open)document.querySelectorAll('.aba-desktop-dropdown[open]').forEach(function(other){if(other!==item)other.open=false})});item.addEventListener('pointerenter',function(event){if(event.pointerType==='mouse')item.open=true});item.addEventListener('pointerleave',function(event){if(event.pointerType==='mouse'&&!item.contains(document.activeElement))item.open=false})});
document.addEventListener('click',function(event){const button=event.target.closest('.aba-ticker-pause');if(!button)return;const ticker=button.closest('[data-ticker]');const paused=ticker.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'▶':'Ⅱ'});
document.addEventListener('toggle',function(event){const item=event.target;if(!item.matches('.aba-category')||!item.open)return;const nav=item.closest('.aba-desktop-nav');item.style.setProperty('--aba-menu-top',Math.ceil(Math.max(nav.getBoundingClientRect().bottom,item.closest('.aba-fast').querySelector('.aba-ticker').getBoundingClientRect().bottom))+'px');document.querySelectorAll('.aba-category[open]').forEach(function(other){if(other!==item)other.open=false})},true);
window.addEventListener('resize',function(){document.querySelectorAll('.aba-category[open]').forEach(function(item){item.open=false})});
window.addEventListener('scroll',function(){document.querySelectorAll('.aba-category[open]').forEach(function(item){item.open=false})},{passive:true});

(function(){
const media=window.matchMedia('(max-width:989px)');
let moved=[];
function adapt(){
const header=document.querySelector('.aba-fast');if(!header)return;
const panel=header.querySelector('.aba-fast-menu>nav');if(!panel)return;
if(media.matches&&!moved.length){
const category=header.querySelector('.aba-desktop-nav');
const league=document.querySelector('.aba-nl-nav');
[league,category].forEach(function(node){if(!node)return;const marker=document.createTextNode('');node.before(marker);moved.push({node:node,marker:marker});panel.prepend(node);if(node===category)node.classList.add('aba-mobile-collections')});
}else if(!media.matches&&moved.length){
moved.forEach(function(item){item.marker.replaceWith(item.node);item.node.classList.remove('aba-mobile-collections')});moved=[];header.querySelector('.aba-fast-menu').open=false;
}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',adapt);else adapt();
media.addEventListener('change',adapt);
document.addEventListener('shopify:section:load',adapt);
})();

(function(){
function closeOtherMobilePanels(active){
  if(!window.matchMedia('(max-width:989px)').matches)return;
  const scope=active.closest('.aba-fast, .aba-nl-nav');
  if(!scope)return;
  document.querySelectorAll('.aba-fast details[open], .aba-nl-nav details[open]').forEach(function(other){
    if(other!==active&&!other.contains(active)&&!active.contains(other))other.open=false;
  });
}
document.addEventListener('click',function(event){
  const summary=event.target.closest('summary');
  if(!summary)return;
  const active=summary.parentElement;
  if(active.tagName==='DETAILS'&&!active.open)closeOtherMobilePanels(active);
},true);
document.addEventListener('toggle',function(event){
  if(event.target.tagName==='DETAILS'&&event.target.open)closeOtherMobilePanels(event.target);
},true);
})();


(function(){
const media=window.matchMedia('(max-width:989px)');
function searchLabel(){document.querySelectorAll('.aba-fast input[type="search"]').forEach(function(input){if(!input.dataset.desktopPlaceholder)input.dataset.desktopPlaceholder=input.placeholder;input.placeholder=media.matches?input.getAttribute('aria-label'):input.dataset.desktopPlaceholder})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',searchLabel);else searchLabel();
media.addEventListener('change',searchLabel);
})();

(function(){
const panels='.aba-fast details,.aba-nl-nav details';
document.addEventListener('toggle',function(event){
 const active=event.target;
 if(!active.matches(panels)||!active.open)return;
 document.querySelectorAll(panels).forEach(function(other){
  if(other.open&&other!==active&&!other.contains(active)&&!active.contains(other))other.open=false;
 });
},true);
document.addEventListener('keydown',function(event){
 if(event.key!=='Escape')return;
 const active=document.activeElement.closest(panels);
 document.querySelectorAll(panels).forEach(function(panel){panel.open=false});
 if(active)active.querySelector('summary').focus();
});
document.addEventListener('click',function(event){
 if(event.target.closest('.aba-fast,.aba-nl-nav'))return;
 document.querySelectorAll(panels).forEach(function(panel){panel.open=false});
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
